function pad(n: number): string {
  return n.toString().padStart(2, "0");
}

/** Format a clock time, e.g. "3:07 PM" or "15:07:42". */
export function formatTime(d: Date, hour24: boolean, showSeconds: boolean): string {
  let h = d.getHours();
  let suffix = "";
  if (!hour24) {
    suffix = h >= 12 ? " PM" : " AM";
    h = h % 12 || 12;
  }
  const base = `${hour24 ? pad(h) : h}:${pad(d.getMinutes())}` + (showSeconds ? `:${pad(d.getSeconds())}` : "");
  return base + suffix;
}

export function formatLongDate(d: Date): string {
  return d.toLocaleDateString(undefined, {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}
